import "./datePiker.scss";
import DatePicker, { DateObject } from "react-multi-date-picker";
import React, { useEffect, useRef } from "react";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { Calendar } from "react-multi-date-picker";
import { useState } from "react";
// شمسی
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// میلادی
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
// چلالی
import jalali from "react-date-object/calendars/jalali";
// قمری
import arabic from "react-date-object/calendars/arabic";
import arabic_ar from "react-date-object/locales/arabic_ar";
// هندی
import indian from "react-date-object/calendars/indian";
import indian_hi from "react-date-object/locales/indian_hi";
// رنگ
import "react-multi-date-picker/styles/colors/green.css";
import "react-multi-date-picker/styles/colors/red.css";
import "react-multi-date-picker/styles/colors/yellow.css";
import "react-multi-date-picker/styles/colors/purple.css";
import "react-multi-date-picker/styles/colors/teal.css";
// بک گراند
import "react-multi-date-picker/styles/backgrounds/bg-gray.css";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import "react-multi-date-picker/styles/backgrounds/bg-brown.css";
export default function DatePiker({
  value,
  setValue,
  type_calender,
  // selector,
  location,
  color,
  bg,
  buttons,
  time,
  just_time,
  onlyYear,
  onlyMonth,
  hideWeekDays,
  hideMonth,
  highlightDay,
  color_highlight,
  disableDay,
  weekend,
  disableYearPicker,
  disableMonthPicker,
  plugins,
  mood,
  inputSize,
  width = "",
  readOnly = false,
  minDate = "",
  maxDate = "",
}) {
  const [state, setState] = useState({});
  // const [value, setValue] = useState(new DateObject());
  // type_calender = "persian";
  // // selector = "year";
  // location = "right";
  // color = "purple";
  // bg = "bg-dark";
  // buttons = true;
  // time = false;
  // just_time = false;
  // onlyYear = false;
  // onlyMonth = false;
  // hideWeekDays = true;
  // hideMonth = false;
  // highlightDay = true;
  // color_highlight = "red";
  // disableDay = true;
  // weekend = "highlit";
  // showMonthPicker = false;
  // showYearPicker = true;
  // plugins = true;
  // mood = "multi";
  // inputSize = "md";
  // sm/md/text

  // type mood :single multi domain weekRange
  const moodMultiFun = () => {
    if (mood == "multi") {
      return true;
    } else {
      return false;
    }
  };
  const moodDomainFun = () => {
    if (mood == "domain") {
      return true;
    } else {
      return false;
    }
  };
  const moodWeekRangFun = () => {
    if (mood == "weekRange") {
      return true;
    } else {
      return false;
    }
  };
  // highlit & disable weekend
  const mapDays = ({ date }) => {
    let props = {};
    let isWeekend = date.weekDay.index === 6;

    if (weekend == "highlight") {
      if (isWeekend) props.className = `highlight highlight-${color_highlight}`;

      return props;
    } else if (weekend == "dis") {
      if (isWeekend)
        return {
          disabled: true,
          style: { color: color_highlight },
          onClick: () => alert("آخر هفته ها غیر فعال هستند"),
        };
    }
  };

  // plugins :single multi domain weekRange

  const pluginsFun = () => {
    if (time == true) {
      return [<TimePicker position="bottom" />];
    } else if (mood == "single") {
      return [<DatePanel position="left" />];
    } else if (mood == "multi") {
      return [<DatePanel markFocused position="left" />];
    } else if (mood == "domain") {
      return [<DatePanel position="left" />];
    } else if (mood == "weekRange") {
      return [<DatePanel position="left" />];
    }
  };

  const selectType = (type_calender) => {
    switch (type_calender) {
      case "arabic":
        return arabic;
        break;
      case "indian":
        return indian;
        break;
      case "persian":
        return persian;
        break;
      case "jalali":
        return jalali;
        break;
      case "gregorian":
        return gregorian;
        break;
      default:
        return persian;
    }
  };
  const selectLangueg = (type_calender) => {
    switch (type_calender) {
      case "arabic":
        return arabic_ar;
        break;
      case "indian":
        return indian_hi;
        break;
      case "persian":
        return persian_fa;
        break;
      case "jalali":
        return persian_fa;
        break;
      case "gregorian":
        return gregorian_en;
        break;
      default:
        return persian_fa;
        break;
    }
  };

  return (
    <div
      className={`p-datepiker d-flex justify-content-start ${
        location == "right"
          ? "justify-content-start"
          : location == "left"
          ? "justify-content-end"
          : location == "center"
          ? "justify-content-center"
          : ""
      }`}
    >
      <div className=" " style={{ width: "100%" }}>
        <DatePicker
          minDate={minDate}
          maxDate={maxDate}
          readOnly={readOnly}
          render={<CustomInput2 inputSize={inputSize} width={width} />}
          disableYearPicker={disableYearPicker}
          disableMonthPicker={disableMonthPicker}
          onlyYearPicker={onlyYear}
          onlyMonthPicker={onlyMonth}
          disableDayPicker={just_time}
          hideMonth={hideMonth}
          // format={`MM/DD/YYYY HH:mm:ss`}
          // plugins={time == true ? [<TimePicker position="bottom" />] : []}
          plugins={plugins == true ? pluginsFun() : []}
          className={`${color} ${bg}`}
          buttons={buttons}
          hideWeekDays={hideWeekDays}
          value={value}
          onChange={(e) => setValue(e)}
          calendar={selectType(type_calender)}
          locale={selectLangueg(type_calender)}
          mapDays={highlightDay == true ? mapDays : ""}
          multiple={moodMultiFun()}
          range={moodDomainFun()}
          weekPicker={moodWeekRangFun()}
          onFocusedDateChange={(dateFocused, dateClicked) => {
            setState({ dateFocused, dateClicked });
          }}
          onClose={() => setState({})}
        />{" "}
      </div>
    </div>
  );
}
function CustomInput2({ openCalendar, value, inputSize, width }) {
  return (
    <input
      style={{ width: width }}
      className={` inputStyle form-control form-control-${inputSize}`}
      // placeholder={``}
      onFocus={openCalendar}
      value={value}
      readOnly
    ></input>
  );
}
